import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-update-branch',
  templateUrl: './update-branch.component.html',
  styleUrls: ['./update-branch.component.css']
})
export class UpdateBranchComponent implements OnInit {

  editForm: any | FormGroup
  product:any = []
  branchId: any = "";
  cid:any

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getallBranch()
    this.editForm = this.fb.group({
      name: [''],
      version: [''],
      group:[''],
      code:[''],
      description:[''],
      id:['']
    })  
  }


  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getallBranch()
  }


  updateBranch(){
    let body = {
      "id": this.editForm.get('id').value,
      "branchMasterId":this.branchId,
      "version": String(this.editForm.get('version').value),
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "name": String(this.editForm.get('name').value),
      "cid": Number(this.cid),
    }

    console.log(body)
    this.generic_service.updateBranch(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getallBranch()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getallBranch(){
    this.generic_service.getBranch().subscribe(
      (response:any)=>{
        this.product = response.response;
      }
    )
  }

  getBranchById(id:any){
    this.branchId = id
    this.generic_service.getBranchById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
          version: response.response.version,
          description: response.response.description,
          id: response.response.id
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }
}